import { render } from "./RegisterClosed.vue?vue&type=template&id=066d8a94"
import script from "./RegisterClosed.vue?vue&type=script&lang=js"
export * from "./RegisterClosed.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__